export interface IDriverMinimalSchema {
    id: string;
    fullName: string;
}

export interface IVehicleMinimalSchema {
    id: string;
    licensePlate: string;
    name?: string;
}

export interface ISemitrailerMinimalSchema {
    id: string;
    name: string;
    licensePlate?: string;
}
